import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link } from '@material-ui/core';
import { useTypedSelector, useAppDispatch } from 'app/store';
import { cleanError, OrderError } from 'reducers/errorCatcher.reducer';
import { useTranslation, Trans } from 'react-i18next';

const ErrorModal = () => {
  const transitionDurationMilliseconds = 0;
  const { data, place } = useTypedSelector(state => state.error.error);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleClose = () => {
    dispatch(cleanError());
  };

  const getMessage = (errorData: any, place: string) => {
    const orderError = errorData as OrderError;

    if (orderError?.errors) {
      if (orderError.errors.connectivity) {
        return (
          <>
            {t(
              'billing:components.errorsModal.messages.connectivityError',
              'Failed to process your request. Please try again later.'
            )}
          </>
        );
      } else if (orderError.errors.insufficientFunds) {
        return (
          <>
            {t(
              'billing:components.errorsModal.messages.insufficientFundsError',
              'Payment failed. Please check that the selected payment method has sufficient amount of funds or select another payment method.'
            )}
          </>
        );
      } else if (orderError.errors.account) {
        return (
          <>
            {t(
              'billing:components.errorsModal.messages.accountError',
              'Following information has failed to be submitted:'
            )}{' '}
            {orderError.errors.account.join(', ')}
          </>
        );
      } else if (orderError.errors.order) {
        return (
          <>
            {orderError.errors.order.join(', ')}.{' '}
            {t('billing:components.errorsModal.messages.orderError', 'Please try again later.')}
          </>
        );
      } else if (orderError.errors.taxId) {
        return (
          <Trans i18nKey="billing:components.errorsModal.messages.taxIdError">
            The Company with this ID already exists. If you want to sign in to your existing account, please click{' '}
            <Link href="https://pecdata.com/">here</Link>
          </Trans>
        );
      }
    }

    if (place === 'companyData/createAccount.rejected') {
      return <>{t('billing:components.errorsModal.messages.unknownError', 'Unknown error, please try again later.')}</>;
    } else {
      return <>{t('billing:components.errorsModal.messages.somethingWentWrong', 'Oops! Something went wrong.')}</>;
    }
  };

  return (
    <Dialog
      open={!!data}
      onClose={handleClose}
      transitionDuration={transitionDurationMilliseconds}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{t('billing:components.errorsModal.title', 'Error')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{getMessage(data, place)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          {t('billing:components.errorsModal.btnOk', 'Ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorModal;
